import { Link } from "react-router-dom";
import SearchResultInfo from "../../../components/SearchResultInfo/SearchRsultInfo";
import styles from "./searchresult.module.css";
import { SearchResultItemDt } from "../../../Models/SearchModel";
import { useState } from "react";
import LoadingIcon from "../../../components/LoadingIcon/LoadingIcon";
import InfoPopup from "../../../components/InfoPopup";


const getQualityStyle = (quality: number) => {
  switch (quality) {
    case 3:
      return styles.gold;
    case 2:
      return styles.silver;
    case 1:
      return styles.bronze;
    default:
      return styles.draft;
  }
};
const getQualitytext = (quality: number) => {
  switch (quality) {
    case 3:
      return "GOLD ALTERNATIVE";
    case 2:
      return "SILVER ALTERNATIVE";
    case 1:
      return "BRONZE ALTERNATIVE";
    default:
      return "DRAFT";
  }
};
export default function SearchResult({ quality, item }: { quality: number, item: SearchResultItemDt }) {
  const qualityStyle = getQualityStyle(quality);
  const qualityText = getQualitytext(quality);
  const [showLoader, setShowLoader] = useState(false);

  return (
    <div className={styles.search_result}>
      { showLoader && <LoadingIcon/> }      <div className={`${styles.quality} ${qualityStyle}`}>
        <span>{qualityText}</span>
        <InfoPopup 
          content={getInfoContent(quality, item.isPublished)}
          position="bottom"
        />
      </div>
      <div className={styles.info_container}>
        <div>
        <img className={styles.logotype} src={`/api/file/logotype/${item.logoTypeId}`} alt={item.companyName}/>
        <span className={styles.company_name}>
            {item.title}
        </span>
        <div>
          {item.isPopular && <SearchResultInfo iconType="popular" />}
          {item.isBioBased && <SearchResultInfo iconType="bio" />}
        </div>
        {item.alternativeToCategories.length > 0 && (
          <>
            <span className={styles.mt16}>Alternative to</span>
            {item.alternativeToCategories.map((category, index) => (
              <span key={index}>{category.name}</span>
            ))}
          </>
        )}
        {item.useCategories.length > 0 && (
          <>
            <span className={styles.mt16}>Use</span>
            {item.useCategories.map((category, index) => (
              <span key={index} className="test">{category.name}</span>
            ))}
          </>
        )}
        </div>
        <Link to={`/${item.isPublished ? "alternative" : "draft"}${item.publicUrl}`} className={styles.more_details} onClick={() => setShowLoader(true)}>
          See details and contact supplier
        </Link>
      </div>
    </div>
    )
}

function getInfoContent(level: number, isPublished: boolean): string {
    if (!isPublished) {
        return "This alternative is not yet published and is only visible to you and administrators.";
    }
    
    switch (level) {
        case 0:
            return "This is a draft alternative that is still being reviewed.";
        case 1:
            return "Alternatives that ChemSec has encountered while doing research. According to available information, solutions are safer. However, contact details and in-depth knowledge about the alternatives are lacking. Bronze alternatives can easily be upgraded to Silver if the producer provides additional information.";
        case 2:
            return "After personal contact with the solution providers, ChemSec has examined the alternatives firsthand.";
        case 3:
            return "Alternatives have a third-party hazard assessment verification that ensures the safety of the product.";
        default:
            return "Information about this alternative level.";
    }
}